import { useEffect, useMemo, useRef } from 'react';
import './App.css';
import schools from './data/bortvisninger-combined.cleaned.json';

const APP_TITLE = 'Antallet af midlertidige bortvisninger på Københavns 74 folkeskoler';
const APP_DESCRIPTION =
  'Antal gange i 2025, hvor en elev er blevet udelukket fra undervisningen i mindst en hel skoledag';
const SOURCE_TEXT = 'Kilde: Københavns Kommune';
const FALLBACK_CENTER = [55.6761, 12.5683];

const escapeHtml = (value) =>
  value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');

function App() {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);

  const rows = useMemo(
    () =>
      [...schools].sort(
        (left, right) => right.temporaryExpulsions2025 - left.temporaryExpulsions2025
      ),
    []
  );

  useEffect(() => {
    const leaflet = window.L;

    if (!leaflet || !mapContainerRef.current || mapRef.current) {
      return undefined;
    }

    const map = leaflet.map(mapContainerRef.current, {
      scrollWheelZoom: true,
      zoomControl: true,
    });

    mapRef.current = map;

    leaflet
      .tileLayer('https://tiles.jfmtech.dk/styles/osm-bright/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '&copy; OpenStreetMap contributors, Tiles &copy; JFM',
      })
      .addTo(map);

    rows.forEach((school) => {
      const popupHtml = `<strong>${escapeHtml(
        school.schoolName
      )}</strong><br/>Midlertidige bortvisninger i 2025: ${school.temporaryExpulsions2025}`;

      leaflet
        .marker([school.coordinates.lat, school.coordinates.lon])
        .addTo(map)
        .bindPopup(popupHtml);
    });

    const bounds = leaflet.latLngBounds(
      rows.map((school) => [school.coordinates.lat, school.coordinates.lon])
    );

    if (bounds.isValid()) {
      map.fitBounds(bounds.pad(0.08));
    } else {
      map.setView(FALLBACK_CENTER, 11);
    }

    return () => {
      map.remove();
      mapRef.current = null;
    };
  }, [rows]);

  return (
    <main className="app-shell">
      <section className="intro-panel">
        <h1>{APP_TITLE}</h1>
        <p>{APP_DESCRIPTION}</p>
        <small>{SOURCE_TEXT}</small>
      </section>

      <section className="map-panel" aria-label="Kort over skoler med midlertidige bortvisninger i 2025">
        <div ref={mapContainerRef} className="leaflet-map" />
      </section>
    </main>
  );
}

export default App;
